import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BarcodeParseResult } from '../models/barcode';
import { BarcodeParseProvider } from '../barcode-scanner/barcode-parse-provider';

/**
 * Authoritative barcode parse over the backend GS1 endpoint. Implements {@link BarcodeParseProvider} so it
 * can back the scanner's `BARCODE_PARSE_PROVIDER` token seam (wired once in `CoreModule`). The relative
 * `api/...` URL lets Homer's `HttpClientInterceptor` prepend the base URL and attach the JWT.
 */
@Injectable({ providedIn: 'root' })
export class BarcodeParseApiService implements BarcodeParseProvider {
    private readonly http = inject(HttpClient);

    /** POSTs a scanned value to `api/EpcisBarcode/parse` and returns the authoritative decode. */
    parse(value: string, symbology?: string): Observable<BarcodeParseResult> {
        return this.http.post<BarcodeParseResult>('api/EpcisBarcode/parse', { value, symbology });
    }
}
